import React from 'react';
import { MultipleSelectField } from '../../../../ui-toolkit';
import { useListRolesQuery } from '../../../../API/roles/RolesApi';
import { rolesOptions } from '../../../../types/roles/rolesOptions';

export const SelectInternalContactRoles: React.FC = () => {
  const { data: roles = [] } = useListRolesQuery();

  return (
    <MultipleSelectField
      name={'roles'}
      options={rolesOptions(roles)}
      isClearable={true}
      label={'Roles'}
    />
  );
};
